<template>
    <div
        v-if="!RENMINWANG_TYPE && !baidu_toufang__footer_shenhe && !$route.meta.hideFooter"
        class="footerNav"
        id="footerNav"
    >
        <ul :class="CHANNEL_CHANNELTYPE && hideBannerAndConsult?'footerNav_for_weizan':''">
            <v-touch tag="li" v-bind:class="{'selected':curPage=='showIndex'}" v-on:tap="toPage('/index', '测评大厅')">
                <i class="index"></i>
            </v-touch>
            <v-touch v-if="!isHpnk" tag="li" v-bind:class="{'selected':curPage=='sorts'}" v-on:tap="toPage('/sorts', '全部分类')">
                <i class="sorts"></i>
            </v-touch>
            <v-touch
                v-if="!isHideVipEntrance && !CHANNEL_NOT_LOGIN" tag="li"
                v-bind:class="{
                'selected':curPage=='vip4-user-center' || curPage=='vip4Detail'
                }"
                v-on:tap="toPage('HWZX', '会员中心')">
                <i class="vipUserCenter"></i>
            </v-touch>
            <v-touch
                v-if="CHANNEL_CHANNELTYPE && hideBannerAndConsult" tag="li"
                v-bind:class="{'selected':curPage=='consult'}"
                v-on:tap="toPage('/yxlConsultPage', '心理咨询')">
                <i class="consult"></i>
            </v-touch>
            <v-touch
                tag="li"
                v-bind:class="{
                    'selected':curPage=='myTests'||curPage=='noLoginCenter',
                    'is-notlogin': CHANNEL_NOT_LOGIN
                }"
                v-on:tap="toPage('/mine/0', '我的测评')"
            >
                <i class="mine">
                    <i
                        v-if="notCompleteCount.notCompleteConsultCount || notCompleteCount.notCompleteOrderCount"
                        class="icon-dot"
                    ></i>
                </i>
            </v-touch>
        </ul>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
import APIS from '../../apis';

    export default {
        name: 'footerNav',
        components: {
        },
        computed: {
            ...mapGetters(['notCompleteCount']),

            routerPath () {
                return this.$route.path
            },
            ...mapState([
                'channelId',
            ])
        },
        data() {
            return {
                curPage: 'index',
                showQrcode: false,
                hasUnfinishConsult: false
            }
        },
        mounted() {
            this.iconSwitch();
            this.getConsultFormRedDot()
        },
        watch: {
            routerPath: function () {
                this.iconSwitch();
            },

            userInfo(userInfo) {
                if(userInfo.userKey) {
                    this.getConsultFormRedDot()
                }
            },
        },
        methods: {
            ...mapMutations([
                'setNotCompleteCount'
            ]),

            getConsultFormRedDot(){
                if (!this.userInfo.userKey) return
                this.$http.get(APIS.notCompleteCount, {
                    params: {
                        userKey: this.userInfo.userKey,
                        channelId: this.channelId
                    }
                }).then(res => {
                    if (+res.data.code === 1) {
                        this.setNotCompleteCount(res.data.data || {})
                    }
                })
            },

            iconSwitch(routerName) {
                if (!!routerName) {
                    this.$data.curPage = routerName;
                } else {
                    this.$data.curPage = this.$route.name;
                }
            },
            showQrCode() {
                event.stopPropagation();
                event.preventDefault();
                this.$data.showQrcode = true;
            },
            hideQrCode() {
                this.$data.showQrcode = false;
                event.stopPropagation();
                event.preventDefault();
            },
            toPage(routerPath, button_name) {
                this.$wechatTrackEvent('weizhan_cepinghome_menu', {
                    button_name: button_name
                })
                // 跳咨询首页
                if (routerPath === '/yxlConsultPage') {
                    location.href = 'https://m.xinli001.com/consult/newUserWelfare?channel_flag=ctdl_yxljxwz_zxtab'
                    return
                }
                // 是测评会员：进入测评会员权益页面；
                // 不是测评会员：进入测评会员购买页。
                if (routerPath === 'HWZX') {
                    if(this.isCpVip) {
                        routerPath = '/vip4UserCenter'
                    } else {
                        routerPath = '/vip4Detail'
                    }

                }

                const that = this;
                // 免登陆切换路径
                let newPath = (routerPath == '/mine/0')&&that.CHANNEL_NOT_LOGIN ? '/noLoginCenter' : routerPath
                that.iconSwitch(newPath);
                if (that.$route.path == newPath) {
                    location.reload()
                } else if (routerPath === '/vip4UserCenter' || routerPath === '/vip4Detail') {
                    that.$router.push({
                        path: newPath,
                        query: {
                            channelId: that.channelId,
                            isFooterNav: 1,
                            _source_page_: encodeURIComponent(this.$route.meta && this.$route.meta.title),
                            sourceName: routerPath === '/vip4Detail' ? 'cphomemenuvipcenter' : this.$route.query.sourceName
                        }
                    })
                } else {
                    that.$router.push({
                        path: newPath,
                        query: {
                            channelId: that.channelId
                        }
                    })
                }
            },
            stopScroll() {
                event.preventDefault();
                event.stopPropagation();
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../scss/function";

    .footerNav {
        height: topx(98rem);
        ul {
            width: 10rem;
            height: topx(98rem);
            position: fixed;
            z-index: 3;
            bottom: 0;
            display: flex;
            justify-content: space-between;
            background: #FFFFFF;
            box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.07);
            padding-bottom: env(safe-area-inset-bottom);
            &.footerNav_for_weizan {
                li {
                     &.selected {
                        .index {
                            background: url('../../assets/show/footer/icon-home_on_wx.png');
                            background-size: cover;
                        }
                        .sorts {
                            background: url('../../assets/show/footer/icon-sort_on_wx.png');
                            background-size: cover;
                        }
                    }
                    i {
                        &.index {
                            background: url('../../assets/show/footer/icon-home_wx.png');
                            background-size: cover;
                        }
                        &.sorts {
                            background: url('../../assets/show/footer/icon-sort_wx.png');
                            background-size: cover;
                        }
                    }
                }
            }
        }
        li {
            flex: 1 1 0;
            font-size: 12px;
            color: #999999;
            line-height: 1.1;
            text-align: center;
            &.selected {
                .index {
                    background: url('../../assets/show/footer/icon-home_on.png');
                    background-size: cover;
                }
                .sorts {
                    background: url('../../assets/show/footer/icon-sort_on.png');
                    background-size: cover;
                }
                .vipUserCenter {
                    background: url('../../assets/show/footer/icon-vipUser_on.png');
                    background-size: cover;
                }
                .mine {
                    background: url('../../assets/show/footer/icon-mine_on.png');
                    background-size: cover;
                }

                &.is-notlogin {
                    .mine {
                        background: url('../../assets/show/footer/icon-mine_on-notlogin.png');
                        background-size: cover;
                    }
                }
                &.consult {
                    background: url('../../assets/show/footer/icon-consult_on.png');
                    background-size: cover;
                }
            }
            a {
                color: inherit;
            }
            i {
                display: inline-block;
                width: topx(98rem);
                height: topx(98rem);
                margin-bottom: topx(5rem);
                &.index {
                    background: url('../../assets/show/footer/icon-home.png');
                    background-size: cover;
                }
                &.sorts {
                    background: url('../../assets/show/footer/icon-sort.png');
                    background-size: cover;
                }
                &.vipUserCenter {
                    background: url('../../assets/show/footer/icon-vipUser.png');
                    background-size: cover;
                }
                &.consult {
                    background: url('../../assets/show/footer/icon-consult.png');
                    background-size: cover;
                }
                &.mine {
                    position: relative;
                    background: url('../../assets/show/footer/icon-mine.png');
                    background-size: cover;

                    .icon-dot {
                        position: absolute;
                        right: topx(20rem);
                        top: topx(12rem);
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        background: #F85343;
                    }
                }
            }

            &.is-notlogin {
                .mine {
                    background: url('../../assets/show/footer/icon-mine-notlogin.png');
                    background-size: cover;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/show/footerNav.vue